import { z } from 'zod';

declare global {
  interface Window {
    publicEnv: Record<string, string>;
  }
}

export const publicEnvSchema = z.object({
  APP_ENV: z.string().default('development'),
  CORE_PLANNER_GOOGLE_TAG_MANAGER_ID: z.string().default(''),
  CORE_PLANNER_HOTJAR_SITE_ID: z.string().default(''),
  CORE_PLANNER_SALESFORCE_URL: z.string().default(''),
});

export const publicEnv = publicEnvSchema.parse(
  typeof window !== 'undefined' && window?.publicEnv ? window.publicEnv : {},
);
